import React from 'react';
import cx from 'classnames';
import Lottie from 'react-lottie';
import animationData from './loader.json';
import {createDataTestId} from '../../../../utils/dataTestId';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

type Props = {
    width?: number;
    height?: number;
    componentClasses?: string;
};

export const Loader = ({width, height, componentClasses}: Props) => {
    return (
        <div
            className={cx('priority-blue-loader', componentClasses)}
            {...createDataTestId('loader')}
        >
            <Lottie options={defaultOptions} width={width} height={height} />
        </div>
    );
};
